// extracted by mini-css-extract-plugin
export default {"answersWrapper":"QuestionMultipleChoice_answersWrapper__NYcea"};